import { Button } from '@workspace/ui/components/Button';
import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { IconButton } from '~/components/isolated/IconButton';
import { ValidationTooltip } from '~/components/ModalSlotsSelectDateV3/components/ValidationTooltip';
import styles from './ModalFooter.module.scss';

interface ModalFooterProps {
  onBack: () => void;
  primaryAction: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
    isLoading?: boolean;
  };
  validationTooltip?: {
    show: boolean;
    message: string;
    onClose: () => void;
  };
}

export const ModalFooter = ({
  onBack,
  primaryAction,
  validationTooltip,
}: ModalFooterProps) => {
  const renderButton = () => {
    const button = (
      <Button
        variant={company.match({
          mcosmetic: 'brand',
          default: 'primary',
        })}
        size="xl"
        onClick={primaryAction.onClick}
        disabled={primaryAction.disabled}
        isLoading={primaryAction.isLoading}
        className={styles.primaryButton}
      >
        {primaryAction.text}
      </Button>
    );

    if (validationTooltip) {
      return (
        <ValidationTooltip
          title={validationTooltip.message}
          open={validationTooltip.show}
          onClose={validationTooltip.onClose}
        >
          {button}
        </ValidationTooltip>
      );
    }

    return button;
  };

  return (
    <div className={styles.footer}>
      <IconButton
        variant="transparent"
        size="XL"
        onClick={onBack}
        className={styles.backButton}
      >
        <Icon type="arrow" size={24} className="icon__rotate-180" />
      </IconButton>

      {renderButton()}
    </div>
  );
};
